var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#facebook)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1205",
    d: "M14.855 7.43475C15.424 7.41675 15.994 7.42974 16.565 7.42974H16.8V4.71774C16.495 4.69074 16.178 4.65074 15.859 4.63374C15.274 4.60974 14.689 4.58274 14.104 4.59474C13.2291 4.58743 12.3704 4.83031 11.629 5.29475C11.2376 5.54762 10.9033 5.87927 10.6472 6.26856C10.3912 6.65786 10.2191 7.09623 10.142 7.55574C10.0771 7.93905 10.0437 8.327 10.042 8.71574C10.025 9.32374 10.042 9.93074 10.042 10.5387V10.7667H7.19995V13.7907H10.019V21.3907H13.463V13.8117H16.273C16.417 12.8037 16.561 11.8117 16.706 10.7717H13.442C13.442 10.7717 13.449 9.27174 13.468 8.62174C13.4525 8.4555 13.4781 8.28802 13.5427 8.13403C13.6072 7.98005 13.7086 7.8443 13.838 7.73875C13.9785 7.62253 14.1409 7.53574 14.3156 7.48351C14.4903 7.43129 14.6737 7.41471 14.855 7.43475Z",
    fill: "#82858B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.99585)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.35b95e68babb58523139d00f71a83431.svg";
export { ForwardRef as ReactComponent };